import React, { useEffect } from "react";
import Routes from "./routes";

import { useStore } from "./store";
import ErrorMessage from "./components/ErrorMessage";
import ErrorBoundary from "./components/ErrorBoundary";
import Epic from "./util/epic";

function App() {
  useEffect(() => {
    const epic = new Epic();
    epic.initiateHandshake();
  }, []);

  const { isErrorMsgShown } = useStore();
  return (
    <ErrorBoundary team="cd.mergeconflict">
      <Routes />
      <ErrorMessage isErrorMsgShown={isErrorMsgShown} />
    </ErrorBoundary>
  );
}

export default App;
